import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsBingAds = {
  show: async(props) => {
    const { default: BingAdsSettings } = await import('@/vue_widgets/mlap/settings/bing_ads/index.vue')
    createVueApp(BingAdsSettings, { props, sidebar })
  }
}
